import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/** Fires a single /api/track call on every route change. Safe & best-effort. */
export default function useTracker() {
  const loc = useLocation();
  const lastRef = useRef(null);
  const firstHitRef = useRef(true);
  useEffect(() => {
    const path = loc.pathname + (loc.search || "");
    if (lastRef.current === path) return;
    lastRef.current = path;
    // Referrer only meaningful on the first hit of a session — document.referrer
    // stays the same across client-side route changes anyway. Sending it once
    // avoids attributing every internal nav to the external referrer.
    const ref = firstHitRef.current ? (document.referrer || null) : null;
    firstHitRef.current = false;
    api.track(path, ref);
  }, [loc.pathname, loc.search]);
}
